import { api } from './client'

// ============================================================================
// Thống kê vật tư nông nghiệp đã dùng theo hộ trồng + vùng trồng.
// Nguồn là nhật ký chăm sóc — kho không ghi vật tư được dùng ở vùng nào.
// ============================================================================

export interface AgriMaterialUsageRow {
    grower_id: string
    grower_name: string
    /** Rỗng = nhật ký không ghi vùng nào; vẫn tính cho hộ. */
    area_id: string
    area_code: string
    area_name: string
    material_id: string
    material_name: string
    material_category: string
    unit: string
    /** Đã chia đều cho số vùng của nhật ký nguồn. */
    quantity: number
    /** true = lượng trên gồm phần chia đều từ nhật ký ghi nhiều vùng. */
    has_split: boolean
    /** Ngày đầu kỳ (YYYY-MM-DD) — chỉ có khi gọi kèm `group_by`. */
    period_start?: string
}

export interface AgriMaterialUsageParams {
    from?: string
    to?: string
    grower_id?: string
    /** Chỉ lấy phần lượng của đúng vùng trồng (bãi) này. */
    area_id?: string
    /** Gom thêm theo kỳ của ngày nhật ký (tuần bắt đầu Thứ Hai). */
    group_by?: 'week' | 'month' | 'year'
}

export const agriMaterialUsageApi = {
    list: (params: AgriMaterialUsageParams) =>
        api.get<AgriMaterialUsageRow[]>('/care-logs/material-usage', {
            params,
        }),
}
